import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { StickyContainer } from 'react-sticky';
import Footer from '@zola/zola-ui/src/components/Footer/Footer';
import { useMobileCheck } from 'cards/hooks/useMobileCheck';
import { asyncComponent } from '../../util/asyncComponent';
import '../stylesheets/_invitations.less';
import { getRoutingPathname } from '../../selectors/routingSelectors';

const CardsModalRoot = asyncComponent(() => import('../components/common/CardsModalRoot'));

// * Public object to expose specific methods to other web
if (typeof window !== 'undefined') {
  window.zolaPaper = window.zolaPaper || {};
}

export default function Cards({ children }) {
  const isBrowser = typeof window !== 'undefined';
  const routingPath = useSelector(getRoutingPathname);
  const isMobile = useMobileCheck();

  const hideFooterOnCustomizationFlow =
    routingPath.includes('/wedding-planning/custom') && !isMobile;

  return (
    <div>
      <div id="invitations" className="invitations">
        <StickyContainer>
          <div className="container-fluid">{children}</div>
        </StickyContainer>
        <CardsModalRoot />
      </div>
      {isBrowser && !hideFooterOnCustomizationFlow ? <Footer /> : null}
    </div>
  );
}

Cards.propTypes = {
  children: PropTypes.element,
};
